
<div class="row">
    <div class="col-12">
  
        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'ORGANIZATION.CREATE_ORGANIZATION' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()" [disabled]="!formValid || !langValid">
                        <i class="bi bi-save"></i>{{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <app-organization-basic [inputDataForForm]="inputDataForForm" (changeFormEvent)="setData($event)"></app-organization-basic>

            </div>

        </div>

    </div>
</div>